import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { Toaster, toast } from 'sonner';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL + '/api',
  });

  api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  const checkUser = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const { data } = await api.get('/auth/me');
        setUser(data);
      }
    } catch (error) {
      console.error("Auth check failed", error);
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkUser();
  }, []);

  const login = async (email, password) => {
    try {
      const formData = new FormData();
      formData.append('username', email);
      formData.append('password', password);
      
      const { data } = await api.post('/auth/login', formData);
      localStorage.setItem('token', data.access_token);
      await checkUser();
      toast.success("¡Bienvenide de nuevo!");
      return true;
    } catch (error) {
      toast.error("Error al iniciar sesión. Verifica tus credenciales.");
      return false;
    }
  };

  const signup = async (userData) => {
    try {
      await api.post('/auth/signup', userData);
      // Auto login after signup
      return await login(userData.email, userData.password);
    } catch (error) {
      toast.error("Error al registrarse. " + (error.response?.data?.detail || ""));
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    toast.info("Sesión cerrada");
  };

  return (
    <AuthContext.Provider value={{ user, login, signup, logout, loading, api }}>
      {children}
      <Toaster position="top-center" />
    </AuthContext.Provider>
  );
};
